import { render, staticRenderFns } from "./BulkOperationForm.vue?vue&type=template&id=58fda261"
import script from "./BulkOperationForm.vue?vue&type=script&lang=js"
export * from "./BulkOperationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports